import React from "react";
import { useTranslation } from 'react-i18next';
import moment from 'moment'

export default function InvoiceSimpleView(props) {
    const { t } = useTranslation();
    const fmt = v => parseFloat(v ?? 0).toFixed(2);
    const mainRenderer = (invoice) => {
        if (invoice) {
            return (
                <div className="mark-display">
                    <div className="mark-chips">
                        {invoice.mark && (
                            <span className="mark-chip mark-chip--primary">
                                <i className="fa fa-tag"></i> MARK: <strong>{invoice.mark}</strong>
                            </span>
                        )}
                        {invoice.uid && (
                            <span className="mark-chip mark-chip--secondary">
                                <i className="fa fa-key"></i> UID: <strong>{invoice.uid}</strong>
                            </span>
                        )}
                        {invoice.cancelledByMark && (
                            <span className="mark-chip mark-chip--danger">
                                <i className="fa fa-ban"></i> {t("cancelledByMark")}: <strong>{invoice.cancelledByMark}</strong>
                            </span>
                        )}
                        {invoice.qrCodeUrl && (
                            <a className="mark-chip mark-chip--qr" href={invoice.qrCodeUrl} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-qrcode"></i> QR Code
                            </a>
                        )}
                    </div>
                </div>
            );
        }
    }

    const issuerRenderer = (invoice) => {
        if (invoice && invoice.issuer) {
            const iss = invoice.issuer;
            const addr = iss.address;
            return (
                <table className="table">
                    <tbody>
                        {iss.name && <tr><td>{t("Name")}: </td><td>{iss.name}</td></tr>}
                        <tr><td>{t("issuerVat")}: </td><td>{iss.vatNumber}</td></tr>
                        <tr><td>{t("Country")}: </td><td>{iss.country}</td></tr>
                        {iss.branch != null && <tr><td>{t("Branch")}: </td><td>{iss.branch}</td></tr>}
                        {addr && <>
                            <tr><td>{t("Street")}: </td><td>{addr.street} {addr.number}</td></tr>
                            <tr><td>{t("PostalCode")}: </td><td>{addr.postalCode}</td></tr>
                            <tr><td>{t("City")}: </td><td>{addr.city}</td></tr>
                        </>}
                    </tbody>
                </table>
            );
        }
    }


    const invoiceHeaderRenderer = (invoice) => {
        if (invoice && invoice.invoiceHeader) {
            const h = invoice.invoiceHeader;
            const intype = "invoice" + h.invoiceType.replace(".", "_");
            const dnh = h.otherDeliveryNoteHeader;
            return (
                <table className="table">
                    <tbody>
                        <tr><td>{t("InvoiceType")}: </td><td>{t(intype)}</td></tr>
                        <tr><td>{t("Series")}: </td><td>{h.series}</td></tr>
                        <tr><td>{t("invoiceNumber")}: </td><td>{h.aa}</td></tr>
                        <tr><td>{t("issuerDate")}: </td><td>{moment(h.issueDate).format('DD/MM/YYYY HH:mm')}</td></tr>
                        {h.dispatchDate && <tr><td>{t("dispatchDateTime")}: </td><td>{moment(h.dispatchDate).format('DD/MM/YYYY')}</td></tr>}
                        {h.movePurpose != null && <tr><td>{t("MovePurpose")}: </td><td>{t("PURPOSE_" + h.movePurpose)}</td></tr>}
                        {h.vatPaymentSuspension != null && <tr><td>{t("vatPaymentSuspension")}: </td><td>{h.vatPaymentSuspension ? t("Yes") : t("No")}</td></tr>}
                        {h.correlatedInvoices?.length > 0 && (
                            <tr><td>{t("correlativeSales")}: </td><td>{h.correlatedInvoices.join(", ")}</td></tr>
                        )}
                        {dnh?.loadingAddress && (
                            <tr><td>{t("loadingAddressHeader")}: </td><td>
                                {dnh.loadingAddress.street} {dnh.loadingAddress.number}, {dnh.loadingAddress.city} {dnh.loadingAddress.postalCode}
                            </td></tr>
                        )}
                        {dnh?.deliveryAddress && (
                            <tr><td>{t("deliveryAddressHeader")}: </td><td>
                                {dnh.deliveryAddress.street} {dnh.deliveryAddress.number}, {dnh.deliveryAddress.city} {dnh.deliveryAddress.postalCode}
                            </td></tr>
                        )}
                    </tbody>
                </table>
            );
        }
    }
    const counterPartRenderer = (invoice) => {
        if (invoice && invoice.counterpart) {
            const cp = invoice.counterpart;
            const addr = cp.address;
            return (
                <table className="table">
                    <tbody>
                        {cp.name && <tr><td>{t("Name")}: </td><td>{cp.name}</td></tr>}
                        <tr><td>{t("counterPartVat")}: </td><td>{cp.vatNumber}</td></tr>
                        <tr><td>{t("Country")}: </td><td>{cp.country}</td></tr>
                        {cp.branch != null && <tr><td>{t("Branch")}: </td><td>{cp.branch}</td></tr>}
                        {addr && <>
                            <tr><td>{t("Street")}: </td><td>{addr.street} {addr.number}</td></tr>
                            <tr><td>{t("PostalCode")}: </td><td>{addr.postalCode}</td></tr>
                            <tr><td>{t("City")}: </td><td>{addr.city}</td></tr>
                        </>}
                    </tbody>
                </table>
            );
        }
    }

    const invoicePaymentMethodsRenderer = (invoice) => {
        if (invoice) {
            var _rows = [];
            if (invoice.paymentMethods) {
                var counter = 0;
                if (invoice.paymentMethods.length > 0) {
                    invoice.paymentMethods.forEach(pm => {
                        var tr = <tr key={counter++}><td>{t("PaymentMethod")}: </td><td>{t("PM_" + pm.type)} </td><td>{fmt(pm.amount)} </td></tr>
                        _rows.push(tr);
                    })
                }
                else  if (invoice.paymentMethods.paymentMethodDetails.length > 0) {
                    invoice.paymentMethods.paymentMethodDetails.forEach(pm => {
                        var tr = <tr key={counter++}><td>{t("PaymentMethod")}: </td><td>{t("PM_" + pm.type)} </td><td>{fmt(pm.amount)} </td></tr>
                        _rows.push(tr);
                    })
                }
            }

            return <table className="table"><tbody>{_rows}</tbody></table>;
        }
    }


    const saleMoreTaxesRenderer = (invoice) => {
        if (invoice) {
            var taxesTotals = invoice.taxesTotals;
            var rows = [];

            if (taxesTotals && taxesTotals.taxes && taxesTotals.taxes.length > 0) {
                taxesTotals.taxes.forEach(tax => {

                    var taxType = null;
                    if (tax.taxType == 1) {
                        taxType = "WITHHOLD_TAXES";
                    }
                    else if (tax.taxType == 2) {
                        taxType = "FEES";
                    }
                    else if (tax.taxType == 3) {
                        taxType = "OTHER_TAXES";
                    }
                    else if (tax.taxType == 4) {
                        taxType = "STUMP_DUTY";
                    }
                    else if (tax.taxType == 5) {
                        taxType = "DEDUCTION";
                    }

                    var taxMap = taxType === "DEDUCTION" ? null : "TAX_MAP_" + tax.taxType + "_" + tax.taxCategory;

                    var tmaptr = taxMap ? t(taxMap) : "";

                    var row = <tr><td>{t(taxType)} </td><td>{tmaptr} </td><td>{fmt(tax.taxAmount)}</td></tr>
                    rows.push(row)
                })
            }


            var table = <table className="table">
                <tbody>
                    {rows}
                </tbody>
            </table>

            return table;
        }
    }


    const invoiceSummaryRenderer = (invoice) => {
        if (invoice) {


            var _rows = [];
            if (invoice.invoiceSummary) {
                _rows.push(<tr key="totalNetValue"><td>{t("totalNetValue")}: </td><td>{fmt(invoice.invoiceSummary.totalNetValue)}</td></tr>);
                _rows.push(<tr key="totalVatAmount"><td>{t("totalVatAmount")}: </td><td>{fmt(invoice.invoiceSummary.totalVatAmount)}</td></tr>);
                _rows.push(<tr key="totalWithheldAmount"><td>{t("totalWithheldAmount")}: </td><td>{fmt(invoice.invoiceSummary.totalWithheldAmount)}</td></tr>);
                _rows.push(<tr key="totalFeesAmount"><td>{t("totalFeesAmount")}: </td><td>{fmt(invoice.invoiceSummary.totalFeesAmount)}</td></tr>);
                _rows.push(<tr key="totalStampDutyAmount"><td>{t("totalStampDutyAmount")}: </td><td>{fmt(invoice.invoiceSummary.totalStampDutyAmount)}</td></tr>);
                _rows.push(<tr key="totalOtherTaxesAmount"><td>{t("totalOtherTaxesAmount")}: </td><td>{fmt(invoice.invoiceSummary.totalOtherTaxesAmount)}</td></tr>);
                _rows.push(<tr key="totalDeductionsAmount"><td>{t("totalDeductionsAmount")}: </td><td>{fmt(invoice.invoiceSummary.totalDeductionsAmount)}</td></tr>);
                _rows.push(<tr key="totalGrossValue"><td>{t("totalGrossValue")}: </td><td>{fmt(invoice.invoiceSummary.totalGrossValue)}</td></tr>);
            }

            return <table className="table"><tbody>{_rows}</tbody></table>;
        }
    }

    const VAT_CATEGORY_LABEL = { 1: "24%", 2: "13%", 3: "6%", 4: "17%", 5: "9%", 6: "4%", 7: "0%", 8: "-" };
    const MU_LABEL = { 1: "Τεμ.", 2: "kg", 3: "lt", 4: "m", 5: "m²", 6: "m³", 7: "παλ.", 8: "τόν." };

    const detailsRenderer = (invoice) => {

        if (invoice && invoice.invoiceDetails && invoice.invoiceDetails.length > 0) {

            var thead = (
                <thead>
                    <tr>
                        <td><b>{t("invoiceLine")}</b></td>
                        <td><b>{t("quantity")}</b></td>
                        <td><b>{t("MUN")}</b></td>
                        <td><b>{t("netvalue")}</b></td>
                        <td><b>{t("Vat")} %</b></td>
                        <td><b>{t("Vat")} €</b></td>
                        <td><b>{t("saleEntryClassifications")}</b></td>
                        <td><b>{t("moreTaxes")}</b></td>
                    </tr>
                </thead>
            );
            var productRows = [];
            var counter = 0;
            invoice.invoiceDetails.forEach(element => {
                var classificationRows = [];
                var classificationCategory;
                var classificationType;


                if (element.expensesClassification && element.expensesClassification.length > 0) {
                    element.expensesClassification.forEach(ec => {
                        classificationCategory = ec.classificationCategory;
                        classificationType = ec.classificationType;
                        var tr = <tr key={counter++}><td>{t(classificationCategory)}({classificationCategory})</td><td>{t(classificationType)}({classificationType})</td><td>{parseFloat(ec.amount).toFixed(2)}</td></tr>
                        classificationRows.push(tr);
                    })

                }
                else if (element.incomeClassification && element.incomeClassification.length > 0) {
                    element.incomeClassification.forEach(ec => {
                        classificationCategory = ec.classificationCategory;
                        classificationType = ec.classificationType;
                        var tr = <tr key={counter++}><td>{t(classificationCategory)}({classificationCategory})</td><td>{t(classificationType)}({classificationType})</td><td>{parseFloat(ec.amount).toFixed(2)}</td></tr>
                        classificationRows.push(tr);
                    })
                }
                else if (element.classificationCategory && element.classificationType) {
                    var tr = <tr key={counter++}><td>{t(element.classificationCategory.replace("category","category_").toUpperCase())}({element.classificationCategory.replace("category","category_").toUpperCase()})</td>
                    <td>{t(element.classificationType.replace("E3","E_3"))}({element.classificationType.replace("E3","E_3")})</td><td>{parseFloat(element.netValue).toFixed(2)}</td></tr>
                    classificationRows.push(tr);
                }
                
                var _trs = [];
                if (element.withheldPercentCategory) {
                    var withheldPercentCategory = t("TAX_MAP_1_" + element.withheldPercentCategory);
                    var tr = <tr key={counter++}><td>{t("WITHHOLD_TAXES")}</td><td>{t(withheldPercentCategory)}</td><td>{parseFloat(element.withheldAmount).toFixed(2)}</td></tr>
                    _trs.push(tr);
                }
                if (element.otherTaxesPercentCategory) {
                    var otherTaxesPercentCategory = t("TAX_MAP_3_" + element.otherTaxesPercentCategory);
                    var tr = <tr key={counter++}><td>{t("OTHER_TAXES")}</td><td>{t(otherTaxesPercentCategory)}</td><td>{parseFloat(element.otherTaxesAmount).toFixed(2)}</td></tr>
                    _trs.push(tr);
                }
                if (element.stampDutyPercentCategory) {
                    var stampDutyPercentCategory = t("TAX_MAP_4_" + element.stampDutyPercentCategory);
                    var tr = <tr key={counter++}><td>{t("STUMP_DUTY")}</td><td>{t(stampDutyPercentCategory)}</td><td>{parseFloat(element.stampDutyAmount).toFixed(2)}</td></tr>
                    _trs.push(tr);
                }
                if (element.feesPercentCategory) {
                    var feesPercentCategory = t("TAX_MAP_2_" + element.feesPercentCategory);
                    var tr = <tr key={counter++}><td>{t("FEES")}</td><td>{t(feesPercentCategory)}</td><td>{fmt(element.feesAmount)}</td></tr>
                    _trs.push(tr);
                }
                if (element.deductionsAmount) {
                    var tr = <tr key={counter++}><td>{t("DEDUCTION")}</td><td></td><td>{fmt(element.deductionsAmount)}</td></tr>
                    _trs.push(tr);
                }

                const vatCatLabel = element.vatCategory != null
                    ? (VAT_CATEGORY_LABEL[element.vatCategory] ?? element.vatCategory)
                    : "";
                const vatExLabel = element.vatExemptionCategory != null
                    ? ` (${t("VAT_CATEGORY_EXCEPTION_" + element.vatExemptionCategory)})`
                    : "";
                const muLabel = element.measurementUnit != null
                    ? (MU_LABEL[element.measurementUnit] ?? element.measurementUnit)
                    : "";
                var _tr = (
                    <tr key={counter++}>
                        <td>{element.lineNumber}{element.lineComments ? ` (${element.lineComments})` : ""}</td>
                        <td>{element.quantity != null ? element.quantity : ""}</td>
                        <td>{muLabel}</td>
                        <td>{parseFloat(element.netValue).toFixed(2)}</td>
                        <td>{vatCatLabel}{vatExLabel}</td>
                        <td>{fmt(element.vatAmount)}</td>
                        <td><table className="table table-bordered table-sm details_child_table"><tbody>{classificationRows}</tbody></table></td>
                        <td><table className="table table-sm table-bordered more_tax_child_table"><tbody>{_trs}</tbody></table></td>
                    </tr>
                );
                productRows.push(_tr);

            });
            var tbody = <tbody>{productRows}</tbody>;
            return <div className="table-responsive"><table className="table details_table table-bordered  table-sm">{thead}{tbody}</table></div>
        }
    }


    return (
        <div className="invoice-viewcontent-container">
            <div className="invoice-viewcontent">
                <div id="invoice-content">
                    {mainRenderer(props.invoice)}

                    <div className="container-fluid" style={{ padding: '8px 12px' }}>
                        <div className="row">
                            <div className="col-xl-3 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-file-text-o" style={{ marginRight: 6 }}></i>
                                        {t("invoiceHeader")}
                                    </div>
                                    <div className="card-body">{invoiceHeaderRenderer(props.invoice)}</div>
                                </div>
                            </div>
                            <div className="col-xl-2 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-user-o" style={{ marginRight: 6 }}></i>
                                        {t("issuer")}
                                    </div>
                                    <div className="card-body">{issuerRenderer(props.invoice)}</div>
                                </div>
                            </div>
                            <div className="col-xl-2 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-users" style={{ marginRight: 6 }}></i>
                                        {t("counterpart")}
                                    </div>
                                    <div className="card-body">{counterPartRenderer(props.invoice)}</div>
                                </div>
                            </div>
                            <div className="col-xl-2 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-credit-card" style={{ marginRight: 6 }}></i>
                                        {t("PaymentMethod")}
                                    </div>
                                    <div className="card-body">{invoicePaymentMethodsRenderer(props.invoice)}</div>
                                </div>
                            </div>
                            <div className="col-xl-3 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-calculator" style={{ marginRight: 6 }}></i>
                                        {t("invoiceSummary")}
                                    </div>
                                    <div className="card-body">{invoiceSummaryRenderer(props.invoice)}</div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-12 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-list" style={{ marginRight: 6 }}></i>
                                        {t("invoiceDetails")}
                                    </div>
                                    <div className="card-body">{detailsRenderer(props.invoice)}</div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-3 card-simple-view-parent">
                                <div className="card card-simple-view">
                                    <div className="card-header">
                                        <i className="fa fa-percent" style={{ marginRight: 6 }}></i>
                                        {t("moreTaxes")}
                                    </div>
                                    <div className="card-body">{saleMoreTaxesRenderer(props.invoice)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}